<template>
  <el-dialog :visible.sync="dialogVisible" title="设置学段年级" custom-class="custom-dialog" :close-on-click-modal="false"
    @opened="dialogOpen" @closed="dialogClose" width="390px" append-to-body>
    <el-form ref="form" :model="form" :inline="true" :rules="rules" label-width="80px" class="demo-form-inline">

      <el-form-item label="学段年级" prop="gradeNames">
        <el-select v-model="form.gradeNames" clearable multiple collapse-tags style="margin-left: 20px;" placeholder="请选择">
          <el-option v-for="item in grades" :key="item.gradeName" :label="item.gradeName" :value="item.gradeName">
          </el-option>
        </el-select>
      </el-form-item>

    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogClose">取消</el-button>
      <el-button :loading="loading" type="primary" @click="save">确定</el-button>
    </div>

  </el-dialog>
</template>
<script>

import http from '../../../../../../common/http';

export default {
  name: 'setGradeForm',
  components: {},
  props: {
    deptId: {
      type: String,
      default() {
        return ""
      }
    },
    esId: {
      type: String,
      default() {
        return ""
      }
    },
    value: Boolean
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      form: {
        gradeNames: [],
      },
      rules: {
          gradeNames: [
              { required: true, message: '请选择学段年级', trigger: 'blur' }
          ],
      },
      grades: []
    }
  },
  watch: {
    value(val) {
      this.dialogVisible = val
    },
    dialogVisible(val) {
      this.$emit('input', val)
    }
  },
  mounted() {
  },
  methods: {
    dialogOpen() {
      // 初始值
      this.form.gradeNames = []
      // 获取数据
      this.getData()
    },
    // 获取设置学段学年与学年数据列表
    getData() {
      let url = this.archiveSegradeListUrl
      let data = {
        deptId: this.deptId,
        esId: this.esId,
      }
      // console.log(JSON.stringify(data))
      // return;
      this.apiPost(url, data).then((res) => {
        if (res.status == 200) {
          this.grades = res.data.gradeList

          // 获取选中值
          let setGradeList = res.data.setGradeList
          for(let i=0; i<setGradeList.length; i++){
            this.form.gradeNames.push(setGradeList[i].gradeName)
          }
        } else {
          this.$commonFn.showTip(res.message, 3)
        }
      }, (err) => {
        console.log(err);
      });
    },
    // 保存
    save() {
      this.$refs['form'].validate((valid) => {
          if(valid){
            let gradenames = new Array()
            let selectGradeNames =  this.form.gradeNames.join(',')
            for(let i=0; i<this.grades.length;i++){
              let gradeName = this.grades[i].gradeName
                if(selectGradeNames.indexOf(gradeName) > -1){
                  gradenames.push(gradeName)
                }
            }

            let url = this.archiveSegradeSaveUrl
            let data = {
              deptId: this.deptId,
              esId: this.esId,
              gradeNames: gradenames.join(','),
            }

            // console.log(JSON.stringify(data))
            // return;

            this.loading = true
            this.apiPost(url, data).then((res) => {
              if (res.status == 200) {
                this.$commonFn.showTip(res.message, 1)

                this.loading = false;
                this.dialogVisible = false;
                this.$emit('submit')
              } else {
                this.$commonFn.showTip(res.message, 3)
              }
              this.loading = false
            }, (err) => {
              console.log(err);
            });
          }
        })
    },
    dialogClose() {
      this.$refs.form.resetFields()
      this.dialogVisible = false
    }
  },
  mixins: [http]
}
</script>


// WEBPACK FOOTER //
// src/components/page/sys/dept/setgrade/components/setGradeForm.vue